import { getPaginatedNotifications } from '@api/notifications';
import { SearchRequest } from '@interfaces/models';
import { useQuery } from '@tanstack/react-query';

export const useGetNotifications = ({ request }: { request: SearchRequest }) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['notifications-table', request],
    queryFn: () => getPaginatedNotifications(request),
  });

  return { data, isLoading, error, refetch };
};
